import { logs } from 'named-logs';
const logger = logs('web3-connection-timeout');
export function timeoutRequest(provider, request, delay = 2) {
    return new Promise((resolve, reject) => {
        let timeout = setTimeout(() => {
            logger.error(`request timed out after ${delay} second`, { provider, request });
            timeout = undefined;
            reject(`request timed out after ${delay} seconds`);
        }, delay * 1000);
        const requestPromise = provider.request(request);
        requestPromise
            .then((response) => {
            if (timeout) {
                clearTimeout(timeout);
                timeout = undefined;
                resolve(response);
            }
            else {
                logger.error(`request succeded after timeout passed`, response);
            }
        })
            .catch((err) => {
            if (timeout) {
                clearTimeout(timeout);
                timeout = undefined;
                reject(err);
            }
            else {
                logger.error(`request failed after timeout passed`, err);
            }
        });
    });
}
